<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="自有司机" name="0"> </el-tab-pane>
      <el-tab-pane label="外协司机" name="1"> </el-tab-pane>
    </el-tabs>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini" :model="searchForm">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="queryTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="所属小队:"  v-if="activeName=='0'">
          <el-select v-model="searchForm.teamOrgCode" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机:"  v-if="activeName=='0'">
          <el-select v-model="searchForm.driverId" filterable placeholder="请选择" clearable  >
            <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row center border :cell-style="setCellStyle" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="driverName" width="" label="司机"></el-table-column>
        <el-table-column prop="teamOrgName" width="" label="所属小队"  v-if="activeName=='0'"></el-table-column>
        <el-table-column prop="pm" width="" label="趟费总额支出排名"></el-table-column>
        <el-table-column prop="zts" width="" label="总运单数"></el-table-column>
        <el-table-column prop="liquidatedAmount" width="" label="拉运完成量"></el-table-column>
        <el-table-column prop="freightAmountTotal" width="" label="趟费总额"></el-table-column>
        <el-table-column prop="pjtf" width="" label="平均单次趟费"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findDriverTollFee } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { organizationTree, cDlists } from '@/api/vgs-driver2.0'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      queryTime: [],
      searchForm: {},
      tableList: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      XDList: [],
      isDaoChu: false,
      sijiList: [],
      activeName: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/realTimeVehicle')
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    this.searchForm.driverOwnership = 0
    this.initQueryTime()
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 190 + 'px'
  },
  watch: {
    queryTime (newVal) {
      if (newVal && newVal.length === 2) {
        const startDate = new Date(newVal[0])
        const endDate = new Date(newVal[1])

        // 如果开始时间不是00:00:00，则修正
        if (startDate.getHours() !== 0 || startDate.getMinutes() !== 0 || startDate.getSeconds() !== 0) {
          startDate.setHours(0, 0, 0, 0)
          newVal[0] = this.formatDateTime(startDate)
        }

        // 如果结束时间不是23:59:59，则修正
        if (endDate.getHours() !== 23 || endDate.getMinutes() !== 59 || endDate.getSeconds() !== 59) {
          endDate.setHours(23, 59, 59, 999)
          newVal[1] = this.formatDateTime(endDate)
        }

        // 如果修正了值，需要重新赋值触发更新
        if (newVal[0] !== this.queryTime[0] || newVal[1] !== this.queryTime[1]) {
          this.$nextTick(() => {
            this.queryTime = [...newVal]
          })
        }
      }
    }
  },
  methods: {
    handleTabClick (e) {
      this.searchForm.driverOwnership = this.activeName
      this.masterList()
      if (this.activeName == '0') {

      } else if (this.activeName == '1') {

      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => e == item.code)
        this.getList(json[0].id)
      }
    },
    getList (teamOrgId) {
      let searchFrom = {
        pageNo: 1,
        pageSize: 1000,
        teamOrgId: teamOrgId,
        driverClassify: 2
      }
      cDlists(searchFrom).then(res => {
        this.sijiList = res.list
      })
    },
    formatDateOnly (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getYesterdayRange () {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)

      // 设置开始时间为昨天的 00:00:00
      const start = new Date(yesterday)
      start.setHours(0, 0, 0, 0)

      // 设置结束时间为昨天的 23:59:59
      const end = new Date(yesterday)
      end.setHours(23, 59, 59, 999)

      return {
        startTime: this.formatDateTime(start),
        endTime: this.formatDateTime(end)
      }
    },

    // 格式化时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    initQueryTime () {
      const { startTime, endTime } = this.getYesterdayRange()
      this.queryTime = [startTime, endTime]
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.driverName === '合计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    masterList () {
      if (this.queryTime) {
        this.$set(this.searchForm, 'startTime', this.queryTime[0])
        this.$set(this.searchForm, 'endTime', this.queryTime[1])
      } else {
        this.$set(this.searchForm, 'startTime', '')
        this.$set(this.searchForm, 'endTime', '')
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findDriverTollFee(this.searchForm)
        .then(res => {
          console.log(res)
          loading.close()
          this.tableList = res.list
          if (res.list.length > 0) {
            this.tableList.push({
              driverName: '合计',
              freightAmountTotal: res.allFreightAmountTotal,
              liquidatedAmount: res.allLiquidatedAmount,
              pjtf: res.allPjtf,
              zts: res.allZts
            })
          }

          // this.total = res.total
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchForm = {}
      this.searchForm.driverOwnership = this.activeName
      this.initQueryTime()
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/reportw/findDriverTollFeeExcel',
        form,
        '司机趟费报表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
